<template>
    <div>
        <vs-row>
            <vs-col w="12">
                <vs-button
                    flat
                    class="ml-auto"
                    @click="getSaveCampoFormativo()"
                >
                    Guardar docentes a campo formativo masivamente
                </vs-button>
            </vs-col>
            <vs-col v-for="(docente, d) in users" :key="d" sm="6" lg="4" class="p-2">
                <div class="card">
                    <div class="card-body">
                        <div class="text-right mb-2">
                            <md-chip class="'mb-1 mini-chip" :class="getInfo(docente.campo_formativo_id)"><strong>{{docente.campo_formativo_id != '' ? 'Docente vinculado a campo formativo' : 'Docente no vinculado a campo formativo'}}</strong></md-chip>
                        </div>
                        <p class="mb-0"><small>DOCENTE</small></p>
                        <p class="mb-0 text-uppercase"><strong>{{docente.nombres}} {{docente.apellido_paterno}} {{docente.apellido_materno}}</strong></p>
                        <p class="mb-0"><small>MATRÍCULA</small></p>
                        <p class="mb-0"><strong>{{docente.matricula}}</strong></p>
                        <hr>
                        <p>Seleccione el campo formativo que quiera vincular al docente</p>
                        <vs-select filter label="Campo formativo" placeholder="Seleccionar campo formativo" v-model="campo_formativo" :disabled="!campos_formativos.length">
                            <template #message-danger v-if="errorFields.includes('campo_formativo')">
                                Requerido
                            </template>
                            <vs-option v-for="option in campos_formativos" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                        <vs-button
                            flat
                            class="ml-auto"
                            @click="getSaveCampoFormativo()"
                        >
                            Guardar
                        </vs-button>
                    </div>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
export default {
    props:{
        users: {
            type: Array,
            default: []
        },
    },
    data(){
        return{
            campo_formativo: '',
            campos_formativos: [
                {
                    id: 1,
                    text: 'Lenguajes'
                },
                {
                    id: 2,
                    text: 'Saberes y pensamiento científico'
                },
                {
                    id: 3,
                    text: 'Ética, naturaleza y sociedades'
                },
                {
                    id: 4,
                    text:'De lo humano y lo comunitario'
                },
                {
                    id: 5,
                    text:'Sin campo formativo'
                }
            ],
            errorFields: [],
        }
    },
    methods:{
        getInfo(info){
            console.log(info)
            if(info != ''){
                return 'col-green'
            }
        },
        getSaveCampoFormativo(){
        }
    }
}
</script>

<style lang="scss" scoped >
@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
    @include text-colors ('yellow', #febf3d, #fff8ec); 
    @include text-colors ('blue', #37aefb, #cfecfe); 
    @include text-colors ('purple', #6F3E90, #E8DAEF); 

}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);    
}
</style>